import { request } from "./ApiCommon";

function getPricing(successCallback: Function) {
  request("/api/v1/pricing", {method: "GET"})
  ?.then((response) => successCallback(response.data))
  .catch(() => {}) // todo
}

export const pricingApi = { getPricing };
